import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    minHeight: '550px',
    marginTop: '10px',
    borderRadius: '5px',
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    position: 'relative',
  },
  iframe: {
    width: '100%',
    height: '550px',
    border: 'none',
    display: 'block',
  },
  loaderContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '550px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
  },
}));

export default useStyles;
